module.exports = __webpack_public_path__ + "static/media/TimesPro.89e9b1d9.png";